import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DataItem, SummaryItem, SummaryPage, SummaryPageChartData } from '../report.model';
import { ChartComponent } from '../../chart/chart.component';
import { Disclaimer, PoweredBy } from '../report.constants';
import { CustomerReportService } from '../../../services/customer-report.service';

@Component({
  selector: 'summary-report',
  standalone: true,
  imports: [CommonModule, ChartComponent],
  templateUrl: './summary-report.component.html',
  styleUrl: './summary-report.component.scss',
})
export class SummaryReportComponent {
  calculatedData: DataItem[] = [];
  summaryData: SummaryItem[] = [];
  public recentConversations: Array<{emoji: string, text: string}> = [];
  readonly disclaimer: string = Disclaimer;
  readonly poweredBy: string = PoweredBy;

  @Input() summaryDataObj!: SummaryPage;
  @Input() chartData: SummaryPageChartData = { channelData: [], resolutionData: [] };

  constructor(private customerReportService: CustomerReportService) {}

  ngOnInit() {
    this.calculatedData = [
      { dataTitle: 'Date Range', dataValue: this.summaryDataObj.dateRange },
      { dataTitle: 'Aeroplan Number', dataValue: this.summaryDataObj.aeroplaneNumber },
      { dataTitle: 'Customer Phone Number', dataValue: this.summaryDataObj.phoneNumber },
      { dataTitle: 'Total Interactions', dataValue: this.summaryDataObj.totalConversations },
      { dataTitle: 'Avg. Queue Wait Time', dataValue: this.summaryDataObj.averageQueueWaitTime },
      { dataTitle: 'Avg. Call Hold Time', dataValue: this.summaryDataObj.averageHoldTime },
      { dataTitle: 'Avg. Interaction Time', dataValue: this.summaryDataObj.averageInteractionTime },
      { dataTitle: 'Total Primary Topics', dataValue: this.summaryDataObj.totalPrimaryTopics },
      { dataTitle: 'Total Topics', dataValue: this.summaryDataObj.totalTopics },
      { dataTitle: 'Total Root Causes', dataValue: this.summaryDataObj.totalRootCauses },
    ];

    // Format recent conversations if available
    if (this.summaryDataObj.recentConversationsOverview && this.summaryDataObj.recentConversationsOverview.length > 0) {
      this.recentConversations = this.customerReportService.formatRecentConversations(this.summaryDataObj.recentConversationsOverview);
    } else {
      // Fallback to hardcoded data if API data is not available
      this.recentConversations = [      ];
    }

    this.summaryData = [
      {
        dataTitle: 'Problem',
        dataValue: this.summaryDataObj.summarizationOfSummaries || '',
      },
      {
        dataTitle: 'Most Interactions Involved',
        dataValue: this.summaryDataObj.listOfPrimaryTopics,
      },
      {
        dataTitle: 'Top Root Causes',
        dataValue: this.summaryDataObj.listofRootCauses,
      },
      {
        dataTitle: 'Recent Conversations Overview',
        dataValue: this.summaryDataObj.recentConversationsOverview?.map(conv => conv.OneLineSummary).filter(Boolean).join(', ') || '',
      },
    ];
  }

  get hasRootCauses(): boolean {
    const value = this.summaryData[2]?.dataValue;
    if (!value) return false;
    return value.split(',').some(cause => cause.trim() !== '');
  }

  get rootCausesArray(): string[] {
    const value = this.summaryData[2]?.dataValue;
    if (!value) return [];
    return value.split(',').map(cause => cause.trim()).filter(cause => cause !== '');
  }
}
